<template>
    <div
        class="progress-bar position-relative bg-gray-ultra-light d-flex justify-content-center align-items-center w-100"
        :class="sizeClass">
        <span
            v-if="isRegular"
            class="progress-bar__percents z-index-1"
            :class="colorThemeClass">{{ progress }}%</span>
        <div
            class="progress-bar__bar position-absolute"
            :class="backgroundThemeClass"
            :style="barWidthStyle"></div>
    </div>
</template>

<script>
import { ProgressSizes, PROGRESS_SIZES } from '../../utils/sizes.js';
import themes from '../../mixins/themes.js';

const FULL_PROGRESS_NUMBER = 100;

export default {
    name: 'SbsProgressBar',
    mixins: [themes],
    computed: {
        sizeClass() {
            return `progress-bar--${this.size}`;
        },
        isRegular() {
            return this.size === ProgressSizes.REGULAR;
        },
        barWidthStyle() {
            return { width: `${this.progress}%` };
        },
    },
    props: {
        /**
         * размер прогресс бара
         */
        size: {
            type: String,
            default: ProgressSizes.REGULAR,
            validator: value => PROGRESS_SIZES.includes(value),
        },
        /**
         * проценты прогресса от 0 до 100
         */
        progress: {
            type: [Number, String],
            default: 0,
            validator: value => Number(value) > 0 && Number(value) < FULL_PROGRESS_NUMBER,
        },
    },
};
</script>

<style lang="scss">
.progress-bar {
    overflow: hidden;

    &--regular {
        height: 24px;
        border-radius: 12px;

        .progress-bar__bar {
            border-radius: 12px;
        }
    }

    &--compact {
        height: 10px;
        border-radius: 5px;

        .progress-bar__bar {
            border-radius: 5px;
        }
    }

    &__bar {
        top: 0;
        left: 0;
        height: 100%;
    }

    &__percents {
        @include typo-subsecondary-demi;
    }
}
</style>
